export var ONEPASS_ITEM_SLUG = "onepass";
export var SHOP_BY_BRAND_ID = "shop-by-brand";
export * from "./bottomNavData";
export * from "./accountMenuData";